import { render, staticRenderFns } from "./OrgManageIcon.vue?vue&type=template&id=659b1bc2"
import script from "./OrgManageIcon.vue?vue&type=script&lang=js"
export * from "./OrgManageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports